import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { getScoreboardQuizzes, usePublicApi } from "../api/PublicApi";
import { CircularProgress, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

const Scoreboard = () => {
  const { t } = useTranslation();
  const api = usePublicApi();

  const [pageSize, setPageSize] = React.useState(10);

  const columns = [
    { field: "username", headerName: t("user"), flex: 1 },
    {
      field: "score",
      headerName: t("score"),
      type: "number",
      flex: 0.25,
      valueGetter: ({ value }) => value.toFixed(1),
    },
    {
      field: "date_start",
      headerName: t("start_date"),
      type: "dateTime",
      flex: 1,
      valueGetter: ({ value }) => value && new Date(value),
    },
    {
      field: "date_end",
      headerName: t("finish_date"),
      type: "dateTime",
      flex: 1,
      valueGetter: ({ value }) => value && new Date(value),
    },
    { field: "subcategories_str", headerName: t("subcategories"), flex: 1 },
    { field: "id", headerName: t("id"), flex: 1 },
  ];

  const [loading, setLoading] = useState(true);
  const [quizzes, setQuizzes] = useState([]);
  const [userQuizzes, setUserQuizzes] = useState([]);

  useEffect(() => {
    getScoreboardQuizzes(api)
      .then((response) => {
        setQuizzes(response["data"]);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  const username = window.localStorage.getItem("username");

  useEffect(() => {
    setUserQuizzes(quizzes.filter((quiz) => quiz.username === username));
  }, [quizzes]);

  return loading ? (
    <Stack alignItems="center">
      <CircularProgress />
    </Stack>
  ) : (
    <DataGrid
      rows={userQuizzes}
      columns={columns}
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      rowsPerPageOptions={[5, 10, 15]}
      pagination
      autoHeight
      disableSelectionOnClick
    />
  );
};

export default Scoreboard;
